/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

type Props = {
  missingDataSources: Array<string>;
};

function MissingDataSourceError({ missingDataSources }: Props) {
  return (
    <div css={{ backgroundColor: '#f00', color: '#fff', padding: '8px 16px' }}>
      <h4>Missing Data Sources</h4>
      <p>The following data sources are missing:</p>
      <ul>
        {missingDataSources.map((dataSource) => (
          <li key={dataSource}>{dataSource}</li>
        ))}
      </ul>
    </div>
  );
}

export default MissingDataSourceError;
